export const WEB_SOCKET_URL = process.env.REACT_APP_WEB_SOCKET_URL ?? "";
export const WAREHOUSE_FIELD_FILTER = "entrepot";
